import React from "react";
import Modal from "react-modal";
import { AiFillCloseCircle } from "react-icons/ai";

const ModalView = ({
  isModaOpen,
  setIsModalOpen,
  title,
  children,
  onClose,
}) => {
  const customStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      backgroundColor: "white",
      // height: "100%",
      // minHeight: "300px",
      maxHeight: "90vh",
      maxWidth: "90vw",
      // minWidth: "500px",
      // width: "100%",
      // overflowY: "auto",
      padding: "10px",
    },
    overlay: { zIndex: 3000 },
  };

  const closeModal = () => {
    setIsModalOpen(false);
    if (onClose) {
      onClose();
    }
  };

  return (
    <Modal isOpen={isModaOpen} onRequestClose={closeModal} style={customStyles}>
      <div className=" d-flex justify-content-between align-items-center bg-white">
        <div>{title}</div>

        <AiFillCloseCircle
          size="2rem"
          color="#CE3B46"
          onClick={closeModal}
          role="button"
        />
      </div>
      <div style={{ overflow: "auto" }}>{children}</div>
    </Modal>
  );
};

export default ModalView;
